import React from "react";
import { cn } from "@/lib/utils";

export const GRADE_DOT = { emerald: "bg-emerald-500", sky: "bg-sky-500", amber: "bg-amber-500", rose: "bg-rose-500" };
export const GRADE_TEXT = { emerald: "text-emerald-600", sky: "text-sky-600", amber: "text-amber-600", rose: "text-rose-600" };
export const GRADE_SOFT = {
  emerald: "bg-emerald-50 text-emerald-700 border-emerald-200",
  sky: "bg-sky-50 text-sky-700 border-sky-200",
  amber: "bg-amber-50 text-amber-700 border-amber-200",
  rose: "bg-rose-50 text-rose-700 border-rose-200",
};
export const GRADE_GRAD = {
  emerald: "from-emerald-500 to-teal-500", sky: "from-sky-500 to-cyan-500",
  amber: "from-amber-500 to-orange-500", rose: "from-rose-500 to-orange-500",
};

const COMP_LABEL = {
  punctuality: "Ketepatan Waktu", overdue_control: "Kendali Keterlambatan",
  revision_quality: "Minim Revisi", accountability: "Kepatuhan Laporan",
};

export function ScoreRing({ score, grade, size = 72 }) {
  const r = (size - 10) / 2;
  const c = 2 * Math.PI * r;
  const off = c * (1 - score / 100);
  const stroke = { emerald: "#10b981", sky: "#0ea5e9", amber: "#f59e0b", rose: "#f43f5e" }[grade?.color] || "#64748b";
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }} data-testid="score-ring">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#e2e8f0" strokeWidth="7" />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={stroke} strokeWidth="7"
          strokeDasharray={c} strokeDashoffset={off} strokeLinecap="round" style={{ transition: "stroke-dashoffset 0.6s ease" }} />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="text-lg font-extrabold text-slate-800 leading-none">{score}</span>
        <span className={cn("text-[10px] font-bold", GRADE_TEXT[grade?.color])}>{grade?.letter}</span>
      </div>
    </div>
  );
}

export function ExecutionScoreCard({ data, title = "Skor Eksekusi" }) {
  if (!data) return null;
  const { score, grade, components, counts } = data;
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" data-testid="execution-score-card">
      <div className="flex items-center gap-5">
        <ScoreRing score={score} grade={grade} size={92} />
        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide">{title}</p>
          <p className={cn("text-lg font-extrabold", GRADE_TEXT[grade?.color])}>{grade?.label}</p>
          <p className="text-xs text-slate-500 mt-0.5">
            {counts.completed} selesai · {counts.on_time} tepat waktu · {counts.overdue_now} terlambat aktif · {counts.revisions} revisi
          </p>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 mt-4">
        {Object.entries(components).map(([k, v]) => (
          <div key={k}>
            <div className="flex items-center justify-between text-xs mb-1">
              <span className="text-slate-500">{COMP_LABEL[k]}</span>
              <span className="font-bold text-slate-700">{v}%</span>
            </div>
            <div className="h-1.5 rounded-full bg-slate-100 overflow-hidden">
              <div className={cn("h-full rounded-full bg-gradient-to-r", GRADE_GRAD[grade?.color])} style={{ width: `${v}%` }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
